import React from 'react';

export const ISSUE_TYPE_LABELS = {
  bug: 'App Bug',
  feature: 'Feature Request',
  access: 'Access or Login Issue',
  data: 'Incorrect Data',
  performance: 'Performance',
  other: 'Other',
};

export function issueIdLabel(row) {
  const n = Number(row.issueNumber);
  if (!Number.isFinite(n) || n <= 0) return row.id;
  return `ISS-${String(n).padStart(3, '0')}`;
}

export function issueTypeLabel(issueType) {
  const k = String(issueType || '').toLowerCase();
  return ISSUE_TYPE_LABELS[k] || issueType || '—';
}

export function normalizeRole(r) {
  const s = String(r || '').toLowerCase();
  if (s.includes('field cleaner') || s.includes('fieldcleaner')) return 'cleaner';
  if (s.includes('cleaner')) return 'cleaner';
  if (s.includes('super_admin') || s.includes('superadmin')) return 'admin';
  if (s.includes('admin')) return 'admin';
  if (s.includes('contractor')) return 'contractor';
  if (s.includes('manager') || s.includes('supervisor')) return 'manager';
  return 'manager';
}

export function roleBadgeClass(role) {
  if (role === 'cleaner') return 'smgmt-badge smgmt-badge--cleaner';
  if (role === 'contractor') return 'smgmt-badge smgmt-badge--contractor';
  if (role === 'admin') return 'smgmt-badge smgmt-badge--violet';
  return 'smgmt-badge smgmt-badge--manager';
}

export function roleLabel(role) {
  if (role === 'cleaner') return 'Cleaner';
  if (role === 'contractor') return 'Contractor';
  if (role === 'admin') return 'Admin';
  return 'Manager';
}

export function normalizeStatus(s) {
  const v = String(s || '').toUpperCase();
  if (v === 'NEW') return 'new';
  if (v === 'UNDER_REVIEW') return 'under_review';
  if (v === 'RESOLVED') return 'resolved';
  const lower = String(s || '').toLowerCase();
  if (lower === 'new') return 'new';
  if (lower === 'under_review') return 'under_review';
  if (lower === 'resolved') return 'resolved';
  return 'new';
}

export function statusBadge(s) {
  const n = normalizeStatus(s);
  if (n === 'resolved') return <span className="smgmt-badge smgmt-badge--resolved">Resolved</span>;
  if (n === 'under_review') return <span className="smgmt-badge smgmt-badge--review">Under Review</span>;
  return <span className="smgmt-badge smgmt-badge--new">New</span>;
}

export function normalizePriority(p) {
  return String(p || '').toLowerCase();
}

export function priorityBadge(p) {
  const key = normalizePriority(p);
  const map = {
    urgent: 'smgmt-badge smgmt-badge--urgent',
    high: 'smgmt-badge smgmt-badge--high',
    medium: 'smgmt-badge smgmt-badge--medium',
    low: 'smgmt-badge smgmt-badge--low',
  };
  const label = key.charAt(0).toUpperCase() + key.slice(1);
  return <span className={map[key] || map.medium}>{label}</span>;
}

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toISOString().slice(0, 10);
  } catch {
    return '—';
  }
}

export function formatDateTime(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '—';
    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  } catch {
    return '—';
  }
}

/** GraphQL enum → form value for selects */
export function statusToFormValue(s) {
  const n = normalizeStatus(s);
  if (n === 'resolved') return 'RESOLVED';
  if (n === 'under_review') return 'UNDER_REVIEW';
  return 'NEW';
}

export function priorityToFormValue(p) {
  const k = normalizePriority(p);
  return k ? k.toUpperCase() : 'MEDIUM';
}
